
import Confirm from '@/components/confirm/confirm.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
export default {
name: 'handleRecord',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
InlineXSwitch,
Previewer,
Popup,
XTextarea,
Group
},
data () {
return {
value: false,
creditModel: false,
refuseModel: false,
refuseReason: '',
creditConten: {name: ''},
list: [],
fileList: [],
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.previewer-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
},
isConfirmshow: false,
confirmtitle: '',
confirmconten: '',
item: {},
seleAwardList: [],
content: '',
scoreList: [],
scoreNum: '',
handleType: ''
}
},
created () {
this.getDetail()
},
methods: {
onCopy () {
this.$vux.toast.text('已复制')
},
onError (error) {
console.log(error)
this.$vux.toast.text('复制失败')
},
onItemShow (item) {
const fileExtension = item.filename.slice(item.filename.lastIndexOf('.') + 1)
if (fileExtension.toLowerCase() === 'word' || fileExtension.toLowerCase() === 'excel' || fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'docx' || fileExtension.toLowerCase() === 'doc' || fileExtension.toLowerCase() === 'ppt' || fileExtension.toLowerCase() === 'pptx') {
window.open('https://view.officeapps.live.com/op/view.aspx?src=' + item.url)
} else if (fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'png' || fileExtension.toLowerCase() === 'jpg' || fileExtension.toLowerCase() === 'jpeg') {
window.open(item.url)
} else {
this.$vux.toast.text('暂时不支持查看此文件，请复制链接在浏览器中下载后查看')
}
},
addAward (item) {
let index = this.seleAwardList.indexOf(item)
index > -1 ? this.seleAwardList.splice(index, 1) : this.seleAwardList.push(item)
},
getScoreList () {
this.$http({
method: 'post',
url: '/workorder/activity/score'
}).then(res => {
this.scoreList = res.rows
}).catch(error => {
console.log(error)
})
},
getDetail () {
var _this = this
var params = new URLSearchParams()
params.append('id', this.$route.query.id)
this.$http({
method: 'post',
url: '/workorder/record/detail',
params: params
}).then(res => {
this.item = res.result
this.getScoreList()
this.list.length = 0
if (res.result.listAttachment) {
res.result.listAttachment.forEach(function (element) {
if (element.mimetype != null && element.mimetype.indexOf('image') !== -1) {
_this.list.push({src: element.url})
} else {
_this.fileList.push(element)
}
})
}
}).catch(error => {
console.log(error)
})
},
logIndexChange (arg) {
},
show (index) {
this.$refs.previewer.show(index)
},
confirmCredit (item) {
this.creditModel = false
this.creditConten = item
},
confirm () {
if (this.handleType === 1) {
if (this.content === '') {
this.$vux.toast.text('请输记录内容')
return false
}
if (this.value) {
if (this.creditConten.name === '') {
this.$vux.toast.text('请选择发放学分类型')
return false
}
if (this.scoreNum === '') {
this.$vux.toast.text('请输入发放学分数量')
return false
}
} else {
if (this.content === '') {
this.$vux.toast.text('请输记录内容')
return false
}
}
} else {
if (this.refuseReason === '') {
this.$vux.toast.text('请输入拒绝理由')
return false
}
}
if (this.value) {
var scores = JSON.stringify([{
scorename: this.creditConten.name,
scorenameId: this.creditConten.id,
scoretype: this.creditConten.account_name,
scoretypeId: this.creditConten.account_type_id,
scorenum: parseInt(this.scoreNum) * 1000
}])
}
var params = {
id: this.$route.query.id,
studentno: this.item.studentno,
userId: this.item.userid,
begintime: this.item.begintime,
endtime: this.item.begintime,
level: this.item.level,
content: this.content,
type: this.handleType,
catalogid2: this.item.catalogid2,
awards: JSON.stringify(this.seleAwardList),
scores: scores,
activityName: this.item.outname
}
if (this.handleType === 1) {
this.$http({
method: 'post',
url: '/workorder/record/doApply',
params: params
}).then(res => {
this.$vux.toast.text('操作成功，成长记录申请已通过')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
}).catch(error => {
console.log(error)
})
} else {
params['remarks'] = this.refuseReason
this.$http({
method: 'post',
url: '/workorder/record/doApply',
params: params
}).then(res => {
this.$vux.toast.text('操作成功，成长记录申请已拒绝')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
}).catch(error => {
console.log(error)
})
}
},
handleswipe (type) {
this.handleType = type
switch (type) {
case 1:
if (this.value) {
this.confirmtitle = '通过成长记录申请'
this.confirmconten = '是否确认通过成长记录申请，并给该学生发放相应的学分？'
} else {
this.confirmtitle = '通过成长记录申请'
this.confirmconten = '是否确认通过成长记录申请，但不给该学生发放学分？'
}
break
case 2:
this.confirmtitle = '拒绝成长记录申请'
this.confirmconten = '是否确认拒绝该学生的成长记录申请？'
break
}
this.isConfirmshow = true
}
}
}




// WEBPACK FOOTER //
// ./src/components/handleRecord/handleRecord.vue